<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-auto" flat>

                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.permanent_address')+' of '+extendConvertVisaDetails.country_name"
                                          class="ml-0"
                                          icon="mdi-map-marker-radius"></confirmation-header-text>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <address-auto-complete
                                :label="$vuetify.lang.t('$vuetify.full_address')"
                                :rules="[rules.required]"
                                :country-code="extendConvertVisaDetails.country_code"
                                v-model="visa.extra.application_data.full_address"
                            >
                            </address-auto-complete>
                        </v-flex>
                        <h4>{{$vuetify.lang.t('$vuetify.reason_for_the_visa')}}</h4>
                        <v-flex md12 xs12>
                            <v-checkbox
                                color="indigo darken-3"
                                label="I have good reputation in Field."
                                v-model="visa_reason"
                                value="0"
                            ></v-checkbox>
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.which_field')"
                                outlined
                                type="text"
                                v-if="visa_reason.includes('0')"
                                v-model="visa.extra.application_data.reputation_field"
                            ></v-text-field>
                            <v-checkbox
                                color="indigo darken-3"
                                label="I would like to contribute in the Field of Nepal."
                                v-model="visa_reason"
                                value="1"
                            ></v-checkbox>
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.which_field')"
                                outlined
                                type="text"
                                v-if="visa_reason.includes('1')"
                                v-model="visa.extra.application_data.contribution_field"
                            ></v-text-field>
                            <v-checkbox
                                color="indigo darken-3"
                                label="I have invested at least one million USD in Nepal."
                                v-model="visa.extra.application_data.invested_million_dollar"
                                value="2"
                            ></v-checkbox>
                            <v-checkbox
                                color="indigo darken-3"
                                label="If others, mention "
                                v-model="visa_reason"
                                value="3"
                            ></v-checkbox>
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.mention')"
                                outlined
                                type="text"
                                v-if="visa_reason.includes('3')"
                                v-model="visa.extra.application_data.other_reason"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import {validationMixin} from "../../../mixins/validationMixin";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";


    export default {
        data: () => ({
            visa_reason: [],
            rules: {
                required: value => !!value || "Required."
            },
        }),
        mixins: [validationMixin],
        components: {
            "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
        },
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            extendConvertVisaDetails() {
                return this.$store.state.VisaSingle.extendConvertVisaDetail;
            }
        },
        watch: {
            visa_reason: function () {
                this.visa.extra.application_data.visa_reason = this.visa_reason;
            }
        },
        mounted() {
            this.visa_reason = this.visa.extra.application_data.visa_reason;
        }
    };
</script>

<style>
</style>
